$(function() {
    var $drawerChk = $('#drawerCheckbox');
    var $body = $('body');
    var $header = $('.header');
    var $headerH;
    var $main = $('.main');
    var $gNav = $header.find('.gnavList');
    /* -------------------------------------------------------------
     モバイル端末に切り替わった時の処理
     ------------------------------------------------------------- */
    var switchingToMobile = function() {
        $headerH = $header.outerHeight();
        $header.css({'position':'fixed'});
        $main.css({'margin-top':$headerH});
        $gNav.css({'padding-top':$headerH});
        $drawerChk.prop('checked',false);
    };
    /* -------------------------------------------------------------
     PCに切り替わった時の処理
     ------------------------------------------------------------- */
    var switchingToPC = function() {
        $headerH = $header.outerHeight();
        $header.css({'position':'fixed'});
        $main.css({'margin-top':0});
        $gNav.css({'padding-top':0});
        $drawerChk.prop('checked',false);
    };
    rwd.init();
    if (rwd.supported) {
        rwd.register('(min-width: 0) and (max-width: 979px)', switchingToMobile);
        rwd.register('(min-width: 980px)', switchingToPC);
        rwd.update();
    } else {
        switchingToPC();
    }
    /* -------------------------------------------------------------
     カレント表示
     ------------------------------------------------------------- */
    $gNav.find('a').each(function(i) {
        var $href = $(this).attr('href');
        if (location.href.match($href)&&!i==0) {
            $(this).addClass('is--current');
        }
    });
});